// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hxvez","header":"styles_header__FQVbT","title":"styles_title__Wutt5","percent":"styles_percent__wNqn7"};